<template>
  <div id="order-supplier-dialog" class="text-xs-center">
    <v-dialog v-model="dialog" width="300" persistent>
      <v-card>
        <v-card-text>
          <div
            class="supplier-selection unselectable"
            :class="{ 'supplier-selected': supplier.value == selectedSupplier }"
            v-for="(supplier, i) in preparedSuppliers"
            :key="i"
            :value="supplier.value"
            @click="selectSupplier(supplier)"
          >
            {{ supplier.text }}
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">{{
            $t("order_supplier_dialog.close")
          }}</v-btn>
          <v-btn :disabled="saveDisabled" color="primary" flat @click="save">{{
            $t("order_supplier_dialog.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
export default {
  name: "order-supplier-dialog",
  props: {
    suppliers: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    saveDisabled() {
      if (this.selectedSupplier == null) return true;
      return false;
    },
  },
  data() {
    return {
      dialog: false,
      order: null,
      preparedSuppliers: [],
      selectedSupplier: null,
      onKeyUp: (e) => {
        if (e.key === "Enter") {
          if (!this.saveDisabled) {
            this.save();
          }
        }
        if (e.key === "Escape") {
          this.dialog = false;
        }
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.selectedSupplier = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  beforeDestroy() {
    document.removeEventListener("keyup", this.keyUpHandler);
  },
  methods: {
    async open(order) {
      this.order = order;
      this.preparedSuppliers = this.prepareSuppliers(order.suppliers);
      this.dialog = true;
    },
    selectSupplier(supplier){
      this.selectedSupplier = supplier.value;
    },
    prepareSuppliers(orderSuppliers) {
      const suppliers = [];
      this.suppliers.forEach((supplier) => {
        const found = orderSuppliers.find((orderSupplier) => {
          return orderSupplier.supplier_id == supplier.id;
        });
        if (!found) {
          suppliers.push({
            text: supplier.short_title,
            value: supplier.id,
          });
        }
      });
      return suppliers;
    },
    async save() {
      const suppliers = [
        {
          supplier_id: this.selectedSupplier,
          ordered_at: Helper.getCurrentDate(),
        },
      ];
      await this.order.addSuppliers(suppliers);
      this.$emit("supplierAdded");
      this.selectedSupplier = null;
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.supplier-selection {
  font-size: 16px;
  cursor: pointer;
}
.supplier-selected{
  background: rgb(84, 84, 160);
  color: white;
}
</style>